/**
 * CodeResultBlock — 代码/Shell 工具输出的格式化渲染
 *
 * 等宽字体 + max-height 滚动 + 柔和背景色。
 */

import { memo } from 'react'
import './result-cards.less'

export const CodeResultBlock = memo(function CodeResultBlock({
  content,
}: {
  content: string
}) {
  if (!content) return null

  return (
    <div className="result-card__code-wrap">
      <pre className="result-card__code">{content}</pre>
    </div>
  )
})
